<template>
    <div class="loading-mask">
        <span class="loading"></span>
        <span class="loading-hint">{{lhint}}</span>
    </div>
</template>
<script>
/* eslint-disable */
export default {
    name:"loading",
    props: ['lhint'],
}
</script>
<style lang="less" scoped>
    .loading-mask{
        /*display: none;*/
        background-color: rgba(0, 0, 0, .7);
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 9999;
        text-align: center;
        padding-top: 45%;
        &.show{
            display: block;
        }
        .loading-hint{
            color: #FFFFFF;
            padding-top: 20px;
            display: block;
            font-size: 1.2rem;
        }
        .loading{
            display: inline-block;
            margin: 15px 0;
            width: 60px;
            height: 60px;
            font-size: 60px;
            line-height: 60px;
            border-radius: 50%;
            position: relative;
            border: 1px solid #fff;
            -webkit-animation: loading-rotating ease 1.5s infinite;
            animation: loading-rotating ease 1.5s infinite;
            &:before {
                content: "";
                position: absolute;
                display: block;
                top: 0;
                left: 50%;
                margin-top: -4px;
                margin-left: -4px;
                width: 8px;
                height: 8px;
                background-color: #fff;
                border-radius: 50%;
            }
        }
    }
    @keyframes loading-rotating {
        0%{
            transform: rotate(0);
        }
        100%{
            transform: rotate(360deg);
        }
    }
</style>
